export default __webpack_public_path__ + "static/media/dab_dance.e24b27ed.gif";